// import React, { useContext, useEffect, useState } from 'react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import PersonnelSearch from '../components/PersonnelSearch';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import PersonnelNavBar from '../components/PersonnelNavBar';
import PersonnelToast from '../components/PersonnelToast';
import TSDILandman from 'src/models/personnel/TSDILandman';
import { IRootState } from 'src/reducers';
import Button from 'src/components/controls/forms/redesign/FormButton';
import BenefitsDashboardDialog from '../dialogs/benefits/BenefitsDashboardDialog';
import InsuranceDashboardDialog from '../dialogs/benefits/InsuranceDashboardDialog';

import '../BenefitStyleSheet.scss';
import PtoDashboardDialog from '../dialogs/benefits/PtoDashboardDialog';
import YearMatrixDialog from '../dialogs/benefits/YearMatrixDialog';
import PersonnelAdvancedQuickFind from '../dialogs/PersonnelAdvancedQuickFindDialog';
import ActiveEmployeesTable from '../components/ActiveEmployees';
import ActiveContractorsTable from '../components/ActiveContractors';

const PersonnelOverviewPage = () => {
    const selectedPersonnel = useSelector((state: IRootState) => state.personnel.selectedPersonnel);
    const [toast, setToast] = useState<{ message: string; color?: string, persistent?: boolean; } | null>(null);
    const [currentView, setCurrentView] = useState<string>('Employee');
    const dispatch = useDispatch();

    // Initial render
    useEffect(() => {
        onCreate();

        return () => {
            onDestroy();
        };
    }, []);

    const onCreate = () => {
        console.log('EmployeeBenefits onCreate()');
    };

    const onDestroy = () => {
        console.log('EmployeeBenefits onDestroy()');
    };

    const showToast = (message: string, color?: string, persistent?: boolean) => {
        setToast({ message, persistent, color });
    };

    const displayTitle = () => {
        const title = 'Personnel Overview';
        return title;
    };

    const displaySubtitle = () => {
        return `Active ${currentView}s`;
    };

    /**
     * Sets the selected Personnel to the store if the given ID is valid and it's not already the same personnel
     * @param personnel - personnel payload
     */
    const setSelectedPersonnel = (personnel: TSDILandman) => {
        if (personnel) {
            personnel?.lmNo !== selectedPersonnel?.lmNo
                ? dispatch({ type: '[personnel] SET_SELECTED_PERSONNEL', payload: personnel })
                : showToast('Selected personnel already set', `rgba(78,117,154,0.5)`);

        } else {
            showToast('Selected personnel is undefined', `rgba(255,0,0,0.5)`);
        }
    };

    // dialogs start
    const toggleYearMatrix = () => {
        dispatch(actions.layout.showDialog(DialogList.YEAR_MATRIX));
    };

    const toggleBenefitsDashboard = () => {
        dispatch(actions.layout.showDialog(DialogList.BENEFITS_DASHBOARD));
    };

    const toggleInsuranceDashboard = () => {
        dispatch(actions.layout.showDialog(DialogList.INSURANCE_DASHBOARD));
    };

    const togglePtoDashboard = () => {
        dispatch(actions.layout.showDialog(DialogList.PTO_DASHBOARD));
    };

    const toggleAdvancedQuickFind = () => {
        dispatch(actions.layout.showDialog(DialogList.PERSONNEL_ADVANCED_QUICK_FIND));
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
    }; // end dialogs

    // switch between active contractors and active employees on main page
    const toggleSelectedView = () => {
        if (currentView === 'Employee') {
            setCurrentView('Contractor');
        } else {
            setCurrentView('Employee');
        }
    };

    return (
        <div>
            <PersonnelNavBar />
            <div>
                {toast && (
                    <PersonnelToast
                        message={toast.message}
                        color={toast.color}
                        onClose={() => setToast(null)}
                        persistent={toast.persistent}
                    />
                )}
            </div>
            <PersonnelSearch toggleAdvancedQuickFind={toggleAdvancedQuickFind} />
            <Page>
                <Page.Section width={12}>
                    <Panel backgroundColor="#D3D3D3">
                        <Panel panelTitle={displayTitle()}>
                            <div style={{ display: 'flex' }}>
                                <h3>{displaySubtitle()}</h3>
                                <div style={{ marginLeft: 'auto' }}>
                                    <Button intent="primary" onClick={toggleSelectedView} text={currentView === 'Employee' ? 'View Active Contractors' : 'View Active Employees'} />
                                </div>
                            </div>
                            <hr />
                            {currentView === 'Employee' && <ActiveEmployeesTable
                                selectedPersonnel={selectedPersonnel}
                                showToast={showToast}
                                setSelectedPersonnel={setSelectedPersonnel}
                            />}

                            {currentView === 'Contractor' && <ActiveContractorsTable
                                selectedPersonnel={selectedPersonnel}
                                showToast={showToast}
                                setSelectedPersonnel={setSelectedPersonnel}
                            />}
                            <hr />
                            <br />
                            <div className="button-row">
                                <Button onClick={togglePtoDashboard} text="PTO Dashboard" />
                                <Button onClick={toggleBenefitsDashboard} text="Benefits Dashboard" />
                                <Button onClick={toggleInsuranceDashboard} text="Insurance Dashboard" />
                                <Button onClick={() => toggleYearMatrix()} text="Year Matrix" />
                            </div>
                        </Panel>
                    </Panel>
                </Page.Section>
            </Page>
            <InsuranceDashboardDialog
                dialogName={DialogList.INSURANCE_DASHBOARD}
                hideDialog={hideDialog}
                showToast={showToast}
            />
            <BenefitsDashboardDialog
                dialogName={DialogList.BENEFITS_DASHBOARD}
                hideDialog={hideDialog}
                showToast={showToast}
            />
            <PtoDashboardDialog
                dialogName={DialogList.PTO_DASHBOARD}
                hideDialog={hideDialog}
                showToast={showToast}
                selectedPersonnel={selectedPersonnel}
            />
            <YearMatrixDialog
                dialogName={DialogList.YEAR_MATRIX}
                hideDialog={hideDialog}
                showToast={showToast}
            />
            <PersonnelAdvancedQuickFind
                dialogName={DialogList.PERSONNEL_ADVANCED_QUICK_FIND}
                hideDialog={hideDialog}
                selectedPersonnel={selectedPersonnel}
                selectPersonnel={setSelectedPersonnel}
            />
        </div>
    );
};

export default PersonnelOverviewPage;


// WEBPACK FOOTER //
// ./src/components/personnel/pages/PersonnelOverviewPage.tsx